export const LOG_LEVELS = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

export function logLevelRank(level) {
  return LOG_LEVELS[level] ?? LOG_LEVELS.info;
}

export function meetsMinLevel(level, minLevel) {
  return logLevelRank(level) >= logLevelRank(minLevel);
}
